import { Delete, TableRows } from "@mui/icons-material";
import { useAtomValue, useSetAtom } from "jotai";
import { selectedRowsAtom } from "./state/selectedRowsAtom";
import { datasetAtom } from "datasheets/views/spreadsheet/state/datasetAtom";
import {
  deleterFunction,
  inserterFunction,
} from "../../model/logic/insertDeleteRows";
import { BaseMenuGroup } from "../common/BaseMenuGroup";

export function EditMenuGroup() {
  const setDataSet = useSetAtom(datasetAtom);
  const selectedRows = useAtomValue(selectedRowsAtom);
  const showSelectedRowsOptions = !!selectedRows && selectedRows.length > 0;
  function insertRows() {
    if (!selectedRows) {
      return;
    }
    setDataSet(inserterFunction(selectedRows));
  }
  function deleteSelectedRows() {
    if (!selectedRows) {
      return;
    }
    setDataSet(deleterFunction(selectedRows));
  }
  return (
    <BaseMenuGroup
      title="Edit"
      menuItems={[
        [
          {
            action: deleteSelectedRows,
            enabled: showSelectedRowsOptions,
            icon: <Delete fontSize="small" />,
            title: "Delete Selected Row",
          },
          {
            action: insertRows,
            enabled: showSelectedRowsOptions,
            icon: <TableRows fontSize="small" />,
            title: "Insert Row",
          },
        ],
      ]}
    />
  );
}
